<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="te-koop-section">
      <h1 class="te-koop-title">Te koop</h1>
      <span class="te-koop-subtitle"
        >Hieronder vindt u een overzicht van de projecten die momenteel te koop
        zijn.</span
      >
    </div>
    <div class="fusing-container14">
      <div class="fusing-blog">
        <div class="fusing-container15">
          <blog-post-card3
            label=" "
            title="Flying faces"
            author="€4500"
            imageSrc="/fusing/flying%20faces-1500w.jpg"
            description="Glasfusing project met vele gezichten. 88x62cm"
            rootClassName="rootClassName1"
          ></blog-post-card3>
        </div>
        <div class="fusing-container16">
          <blog-post-card31
            imageSrc="/fusing/rabbitrun.jpeg"
            label=" "
            title="Rabbitrun"
            author="€1950"
            description="Twee konijnen gemaakt door middel van glasfusing. 62x40cm"
            rootClassName="blog-post-card31root-class-name"
          ></blog-post-card31>
        </div>
        <div class="fusing-container17">
          <blog-post-card3
            label=" "
            title="Sunface"
            author="€3250"
            imageSrc="/fusing/sunface.jpeg"
            rootClassName="rootClassName2"
            description="Een gezicht dat lijkt op een zon, ook een glasfusing project. 70x62cm"
          ></blog-post-card3>
        </div>
        <div class="fusing-container18">
          <blog-post-card31
            title="Papegaai"
            author="€3250"
            imageSrc="/fusing/kickinside2.jpeg"
            rootClassName="blog-post-card31root-class-name1"
            description="Een papegaai gemaakt door middel van glasfusing. 70x62cm"
          ></blog-post-card31>
        </div>
        <div class="fusing-container19">
          <blog-post-card3
            label=" "
            title="Twin birds"
            author="€1950"
            imageSrc="/fusing/twidelitie5-3-2013.JPG"
            rootClassName="rootClassName2"
            description="Twee vogels gemaakt door middel van glasfusing. 62x40cm"
          ></blog-post-card3>
        </div>
        <div class="fusing-container20">
          <blog-post-card31
            title="Dancing Sharks"
            author="€3750"
            imageSrc="/fusing/2beesten.jpeg"
            rootClassName="blog-post-card31root-class-name1"
            description="Twee vissen gemaakt door middel van glasfusing. 74x60cm"
          ></blog-post-card31>
        </div>
        <div class="fusing-container21">
          <blog-post-card3
            label=" "
            title="Toekan"
            author="€2950"
            imageSrc="/fusing/toekan.jpeg"
            rootClassName="rootClassName2"
            description="Toekan gemaakt door middel van glasfusing. 81x45cm"
          ></blog-post-card3>
        </div>
        <div class="fusing-container22">
          <blog-post-card31
            title="Maria"
            author="€3300"
            imageSrc="/brandschilderen/PHOTO-2024-11-30-16-31-07.jpg"
            rootClassName="blog-post-card31root-class-name1"
            description="Maria ruit gemaakt door middel van brandschilderen. 65x63cm"
          ></blog-post-card31>
        </div>
        <div class="fusing-container23">
          <blog-post-card3
            label=" "
            title="Ovalen bloemen ruit"
            author="€95"
            imageSrc="/gestraald/gestraald_tekoop.jpeg"
            rootClassName="rootClassName2"
            description="Gestraalde ovalen ruit met bloemen. 8mm dik, 43x95cm"
          ></blog-post-card3>
        </div>
        <div class="fusing-container24">
          <blog-post-card31
            title="Vis"
            author="€1950"
            imageSrc="/fusing/fusingVis.jpeg"
            rootClassName="blog-post-card31root-class-name1"
            description="Vis gemaakt door middel van glasfusing. 62x34cm"
          ></blog-post-card31>
        </div>
      </div>
    </div>
    <div class="footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import Navbar from "../components/navbar.vue";
import BlogPostCard3 from "../components/blog-post-card3.vue";
import BlogPostCard31 from "../components/blog-post-card31.vue";
import Footer from "../components/footer.vue";

export default {
  name: "TeKoop",
  components: {
    Navbar,
    BlogPostCard3,
    BlogPostCard31,
    Footer,
  },
  metaInfo: {
    title: "Te koop - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Te koop - Langglas",
      },
    ],
  },
};
</script>

<style scoped>
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}

.footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}

.te-koop-section {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}

.te-koop-title {
  font-size: 3rem;
  align-self: center;
  text-align: center;
  padding-top: 150px;
  padding-bottom: 20px;
}

.fusing-container14 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}

.fusing-blog {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.fusing-container15 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}
.fusing-container16 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}
.fusing-container17 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container18 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container19 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container20 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container21 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container22 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.fusing-container23 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  flex-direction: column;
  justify-content: space-between;
}

.te-koop-subtitle {
  text-align: center;
  padding-bottom: 20px;
}
</style>
